import {
  Box,
  BoxProps,
  Badge as ChakraBadge,
  BadgeProps as ChakraBadgeProps,
} from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

interface BadgeProps extends ChakraBadgeProps {
  children: ReactNode;
  badgeContent: ReactNode;
  invisible?: boolean;
  containerStyles?: BoxProps;
}

const Badge: FC<BadgeProps> = ({
  badgeContent,
  invisible,
  children,
  containerStyles,
  ...styles
}) => (
  <Box
    as='span'
    display='block'
    position='relative'
    {...containerStyles}
  >
    {children}
    {!invisible && (
      <ChakraBadge
        borderRadius='full'
        colorScheme='red'
        position='absolute'
        right={0}
        top={0}
        transform='translate(100%, -50%)'
        variant='solid'
        {...styles}
      >
        {badgeContent}
      </ChakraBadge>
    )}
  </Box>
);

export default Badge;
